<template>
    <card>
      <template class="card-header" slot="header">
        <h4 class="card-title">
          Operating System Information
          <button v-if="!noRefresh" class="btn btn-link text-info pull-right" @click="$emit('refreshData')">
            <font-awesome-icon icon="sync"></font-awesome-icon>
          </button>
        </h4>
        <p class="card-category">General information about the OS on the server.</p>
      </template>
      <table class="table table-borderless beast-info-table">
        <tr v-if="!noEnv">
          <th class="beast-key">Environment:</th>
          <td class="beast-value">{{osInfo.environment}}</td>
        </tr>
        <tr>
          <th class="beast-key">Platform:</th>
          <td class="beast-value">{{osInfo.platform}}</td>
        </tr>
        <tr>
          <th class="beast-key">Release:</th>
          <td class="beast-value">{{osInfo.release}}</td>
        </tr>
        <tr>
          <th class="beast-key">Type:</th>
          <td class="beast-value">{{osInfo.type}}</td>
        </tr>
        <tr>
          <th class="beast-key">Hostname:</th>
          <td class="beast-value">{{osInfo.hostname}}</td>
        </tr>
      </table>
    </card>
</template>

<script>
export default {
  props: {
    osInfo: {
      type: Object,
      required: true
    },
    noEnv: {
      type: Boolean,
      default: false
    },
    noRefresh: {
      type: Boolean,
      default: false
    }
  },
  name: "OSInfo"
};
</script>

<style scoped>

</style>
